// extracted by mini-css-extract-plugin
export default {"butcon":"Header_butcon__VMeRL","butcon2":"Header_butcon2__GDUjz","rlogo1":"Header_rlogo1__9uY5C","rlogo2":"Header_rlogo2__EWSoj"};